import { API_URL } from '../../config/api';
import { createDailyUpdateDocument, deleteDailyUpdateDocument } from '../../api/documents';
import { DocumentAttachment } from '../common/DocumentAttachment';

interface DailyUpdatesDocumentAttachmentProps {
  projectId: string;
  recordId: string;
  documentUrl?: string | null;
  fileName?: string | null;
  onUpdate?: () => Promise<void>;
  onDocumentChange?: (documentUrl: string | undefined, fileName: string | undefined) => void;
}

export const DailyUpdatesDocumentAttachment = ({ projectId, recordId, documentUrl, fileName, onDocumentChange }: DailyUpdatesDocumentAttachmentProps) => (
  <DocumentAttachment
    recordLabel="daily update"
    recordKey={`${projectId}-${recordId}`}
    documentUrl={documentUrl}
    fileName={fileName}
    onDocumentChange={onDocumentChange}
    adapter={{
      upload: async (token, file) => {
        const response = await createDailyUpdateDocument(token, projectId, recordId, file);
        // The upload response may carry the URL under another key, or none at all.
        const url = response.url || (response as any).document_url || `${API_URL}/projects/${projectId}/daily-update/${recordId}/document`;
        return { ...response, url };
      },
      remove: (token) => deleteDailyUpdateDocument(token, projectId, recordId),
    }}
  />
);
